import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row } from "antd";
import Page from "../../../common/components/Page";
import { buildAddress, viewDate } from "../../../common/constants/helpers";
import { RootState } from "../../../store";
import EmployeeDetailSummary from "./employee-detail-summary";
import EmployeeTabs from "./employee-tabs";
import { setSelectedEmployee } from "../../../state/globalStore";

const EmployeeDetail = () => {
  const [form] = Form.useForm();
  const { selectedEmployee, activeEmployee } = useSelector((state: RootState) => state.global);
  const [newTaxLayout, setNewTaxLayout] = useState<boolean>(false);
  const [canViewTaxes, setCanViewTaxes] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    form.setFieldsValue({
      ...selectedEmployee,
      startDate: viewDate(selectedEmployee?.startDate),
      fullAddress: buildAddress(selectedEmployee?.addresses[0]),
      email: selectedEmployee?.emails[0]?.emailAddress ?? "N/A",
      phone: selectedEmployee?.phones[0]?.number ?? "N/A"
    });
    const federalTaxes = selectedEmployee?.taxes?.filter((o) => o.taxLocality.toUpperCase() === "FEDERAL");
    setNewTaxLayout(federalTaxes[0]?.new2020W4);
    console.log(activeEmployee.employeeId == selectedEmployee.employeeId);
    console.log(activeEmployee);
    console.log(selectedEmployee.employeeId);
    setCanViewTaxes(activeEmployee?.isAdmin || activeEmployee.employeeId == selectedEmployee.employeeId)
  }, [form, selectedEmployee]);

  useEffect(() => {
    return () => {
      dispatch(setSelectedEmployee(null));
    };
  }, []);

  return (
    <Page>
      <Page.Title title="Employee Information" icon="user" />
      <Page.Content>
        <Row gutter={8}>
          <Col xl={5} lg={5} md={8} sm={24} xs={24}>
            <EmployeeDetailSummary selectedEmployee={selectedEmployee} />
          </Col>
          <Col xl={19} lg={19} md={16} sm={24} xs={24}>
            <EmployeeTabs form={form} selectedEmployeeId={selectedEmployee?.employeeId} selectedEmployee={selectedEmployee} newTaxLayout={newTaxLayout} canViewTaxes={canViewTaxes} />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};

export default EmployeeDetail;
